<div class="products-view" [ngClass]="{'products-view--loading': pageService.isLoading$|async}" [formGroup]="listOptionsForm">
    <div class="products-view__loader"></div>

    <div *ngIf="products?.length" class="products-view__content">
        <div class="view-options__container">
            <div class="view-options__legend">
                {{"showing"|translate}} {{ list.from }}–{{ list.to }}
                {{"of"|translate}} {{ productsCount }}
                {{"results"|translate}}
            </div>

            <div class="products-view__options">
                <div class="view-options" [ngClass]="{
                    'view-options--offcanvas--always': offcanvas === 'always',
                    'view-options--offcanvas--mobile': offcanvas === 'mobile'
                }">
                    <div *ngIf="displayFilters && showSidebar=='true'" class="view-options__filters-button">
                        <button type="button" class="filters-button" (click)="sidebar.open()">
                            <app-icon class="filters-button__icon" name="filters-16" size="16"></app-icon>
                            <span class="filters-button__title">{{filtersButton|translate}}</span>
                            <span class="filters-button__counter" *ngIf="filtersCount > 0">{{ filtersCount }}</span>
                        </button>
                    </div>

                    <!-- <div class="view-options__legend">
                        {{"showing"|translate}} {{ pageService.from }}–{{ pageService.to }}
                        {{"of"|translate}} {{ productsCount }}
                        {{"results"|translate}}
                    </div>
                    <div class="view-options__divider"></div> -->
                    <div *ngIf="showSidebar=='true'" class="view-options__control">
                        <label for="view-options-sort">{{"sort_by"|translate}}</label>
                        <div>
                            <select class="form-control form-control-sm" id="view-options-sort" formControlName="sort">
                                <option value="popular">{{"popular"|translate}}</option>
                                <option value="relevance">{{"relevance"|translate}}</option>
                                <option value="newest">{{"newest"|translate}}</option>
                                <option value="featured">{{"featured"|translate}}</option>
                                <option value="price_asc">{{"price_asc"|translate}}</option>
                                <option value="price_desc">{{"price_desc"|translate}}</option>
                                <!-- <option value="bestseller">{{"bestseller"|translate}}</option> -->
                                <!-- <option value="most_visited">{{"most_visited"|translate}}</option> -->
                            </select>
                        </div>
                    </div>
                    <div class="view-options__control">
                        <label for="view-options-limit">{{"show"|translate}}</label>
                        <div>
                            <select class="form-control form-control-sm" id="view-options-limit" formControlName="limit">
                                <option value="12">12</option>
                                <option value="24">24</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                    </div>

                    <!-- <div class="ltr:ms-3 rtl:mr-3 view-options__layout">
                        <div class="layout-switcher">
                            <div class="layout-switcher__list">
                                <button title="Grid" type="button" class="layout-switcher__button"
                                        [ngClass]="{'layout-switcher__button--active': layout === 'grid'}" (click)="setLayout('grid')">

                                    <app-icon name="layout-grid-16x16" size="16"></app-icon>
                                </button>
                                 <button title="Grid With Features" type="button" class="layout-switcher__button"
                                        [ngClass]="{'layout-switcher__button--active': layout === 'grid-with-features'}" (click)="setLayout('grid-with-features')">

                                    <app-icon name="layout-grid-with-details-16x16" size="16"></app-icon>
                                </button>  
                                <button title="List" type="button" class="layout-switcher__button"
                                        [ngClass]="{'layout-switcher__button--active': layout === 'list'}" (click)="setLayout('list')">

                                    <app-icon name="layout-list-16x16" size="16"></app-icon>
                                </button>
                            </div>
                        </div>
                    </div>  -->
                </div>
            </div>
        </div>

        <div class="products-list">
            <div class="row">
                <div *ngFor="let product of products" class="col col-product_{{layout}} view__{{itemsView}}">

                    <app-product-card-new [product]="product" [layout]="layout"></app-product-card-new>
                </div>
            </div>
        </div>

        <div *ngIf="paginationPageCount > 1" class="products-view__pagination">
            <app-pagination [current]="pageService.page" (pageChange)="listOptionsForm.get('page').setValue($event)" [total]="paginationPageCount"></app-pagination>
        </div>
    </div>
</div>